import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '../components/Modal';
import { supabase } from '../config/supabase';

const SilverRegister = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(true);
  const [formType, setFormType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    idNumber: '',
    phone: '',
    safetyBox: '',
    dob: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');

  const handleFormTypeSelect = (type) => {
    setFormType(type);
    setShowPopup(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match!');
      return;
    }

    try {
      setError('');
      
      // Step 1: Create auth user in Supabase
      const { data: authData, error: authError } = await supabase.auth.signUp({
        email: formData.email,
        password: formData.password,
        options: {
          emailRedirectTo: window.location.origin + '/login',
          data: {
            full_name: `${formData.name} ${formData.surname}`,
            membership_tier: 'Silver'
          }
        }
      });

      if (authError) {
        // Ignore email confirmation errors - user will still be created
        if (!authError.message.includes('email') && !authError.message.includes('confirmation')) {
          setError(authError.message);
          return;
        }
        console.warn('Email confirmation warning:', authError.message);
      }

      // Check if user was created despite email error
      if (!authData?.user) {
        setError('Failed to create account. Please try again.');
        return;
      }

      // Step 2: Create user record with pending status
      const { error: userError } = await supabase
        .from('users')
        .insert([
          {
            id: authData.user.id,
            email: formData.email,
            full_name: `${formData.name} ${formData.surname}`,
            phone: formData.phone,
            membership_tier: 'Silver',
            status: 'pending'
          }
        ]);

      if (userError) {
        setError(userError.message);
        return;
      }

      // Step 3: Create application form record
      const { error: formError } = await supabase
        .from('application_forms')
        .insert([
          {
            user_id: authData.user.id,
            first_name: formData.name,
            last_name: formData.surname,
            email: formData.email,
            phone: formData.phone,
            date_of_birth: formType === 'no' ? formData.dob : null,
            membership_tier: 'Silver',
            status: 'pending',
            areas_of_interest: formType === 'yes' ? [`Safety Box: ${formData.safetyBox}`] : []
          }
        ]);

      if (formError) {
        setError(formError.message);
        return;
      }

      // Success - show modal
      setShowModal(true);
      
    } catch (err) {
      setError(err.message || 'An error occurred during registration');
    }
  };

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <div className="logo-container" style={{textAlign: 'center', marginBottom: '1.5rem'}}>
          <img src="/images/IBVlogo.png" alt="IBV Wealth Club" style={{maxWidth: '150px', height: 'auto'}} />
        </div>

        <h2 className="page-title">Silver Membership Registration</h2>

        {showPopup && (
          <Modal isOpen={showPopup} onClose={() => {}}>
            <p>Do you have a safety deposit box?</p>
            <div className="flex" style={{ gap: '10px', marginTop: '20px' }}>
              <button className="btn btn-primary" onClick={() => handleFormTypeSelect('yes')}>
                Yes
              </button>
              <button className="btn btn-secondary" onClick={() => handleFormTypeSelect('no')}>
                No
              </button>
            </div>
          </Modal>
        )}

        {formType && (
          <div className="card">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  className="form-input"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="surname"
                  className="form-input"
                  placeholder="Surname"
                  value={formData.surname}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="idNumber"
                  className="form-input"
                  placeholder="ID Number"
                  value={formData.idNumber}
                  onChange={handleChange}
                  required
                />
              </div>

              {formType === 'yes' ? (
                <div className="form-group">
                  <input
                    type="text"
                    name="safetyBox"
                    className="form-input"
                    placeholder="Number of Safety Deposit Box"
                    value={formData.safetyBox}
                    onChange={handleChange}
                    required
                  />
                </div>
              ) : (
                <div className="form-group">
                  <input
                    type="date"
                    name="dob"
                    className="form-input"
                    value={formData.dob}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}

              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  className="form-input"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  className="form-input"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="password"
                  name="password"
                  className="form-input"
                  placeholder="Create Password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="password"
                  name="confirmPassword"
                  className="form-input"
                  placeholder="Confirm Password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                />
              </div>

              {error && <div className="alert alert-error">{error}</div>}

              <button type="submit" className="btn btn-primary">
                Register
              </button>

              <button 
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate('/login')}
                style={{marginTop: '1rem', width: '100%'}}
              >
                Back to Login
              </button>
            </form>
          </div>
        )}

        <Modal isOpen={showModal} onClose={() => navigate('/login')}>
          <p>Thank you. Your application is being verified.</p>
          <p>We will contact you in 3–5 business days.</p>
          <button className="btn btn-primary mt-lg" onClick={() => navigate('/login')}>
            OK
          </button>
        </Modal>
      </div>
    </div>
  );
};

export default SilverRegister;
